import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled, { keyframes } from "styled-components";

const slideUp = keyframes`
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: ${theme.lightBlack};
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  animation: ${fadeIn} 0.2s ease-out;
`;

export const SheetPanel = styled.div`
  background: ${theme.whiteText};
  border-radius: 16px 16px 0 0;
  width: 100%;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ${slideUp} 0.3s ease-out forwards;
`;

export const SheetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
`;

export const SheetTitle = styled.h3`
  margin: 0;
  font-size: ${fontSize.font18};
  font-weight: ${fontWeight.black};
  color: ${theme.blackText};
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  border-radius: 4px;

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 24px 24px;
`;

export const ReasonRow = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 0;
  border: none;
  border-bottom: 1px solid ${theme.lightGrey};
  background: none;
  cursor: pointer;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: -2px;
    border-radius: 4px;
  }
`;

export const ReasonTitle = styled.span`
  flex: 1;
  font-size: ${fontSize.font14};
  color: ${theme.blackText};
`;

export const ReasonSubtitle = styled.span`
  font-size: ${fontSize.font12};
  color: ${theme.greyText};
  margin-top: 2px;
`;

export const ReasonContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ChevronWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transform: rotate(90deg);
`;
